import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mall-quote" }
const _hoisted_2 = { class: "mall-quote__toolbar no-print" }
const _hoisted_3 = { class: "mall-quote__toolbar-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "mall-quote__loading",
  "aria-busy": "true"
}
const _hoisted_6 = {
  key: 1,
  class: "mall-quote__empty no-print"
}
const _hoisted_7 = {
  key: 2,
  class: "mall-quote__sheet"
}
const _hoisted_8 = { class: "mall-quote__head" }
const _hoisted_9 = { class: "mall-quote__date" }
const _hoisted_10 = { class: "mall-quote__table" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "is-num" }
const _hoisted_14 = { class: "is-num" }
const _hoisted_15 = { class: "is-num" }
const _hoisted_16 = { class: "mall-quote__totals" }
const _hoisted_17 = { class: "is-total" }

import { computed, onMounted, onUnmounted } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { ensureLiveProducts } from '@/api/mall'
import { useCart } from '@/composables/useCart'
import { useMemberAuth } from '@/composables/useMemberAuth'
import { formatPrice } from '@/constants/mallProducts'
import { formatShippingFeeAmount } from '@/utils/mallShipping'

const QUOTE_PRINT_BODY_CLASS = 'is-mall-quote-print'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallCartQuotePage',
  setup(__props) {

const {
  lines,
  isEmpty,
  loading,
  loaded,
  listSubtotal,
  shippingFee,
  payable,
  reload,
} = useCart()
const { member } = useMemberAuth()

const orgName = computed(() => member.value?.orgName || '기관명 미확인')
const issuedAt = computed(() =>
  new Date().toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }),
)

function onPrint() {
  if (isEmpty.value) return
  window.print()
}

onMounted(async () => {
  document.body.classList.add(QUOTE_PRINT_BODY_CLASS)
  await ensureLiveProducts()
  await reload()
})

onUnmounted(() => {
  document.body.classList.remove(QUOTE_PRINT_BODY_CLASS)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/mall/cart",
        class: "mall-quote__back"
      }, {
        default: _withCtx(() => [
          _createVNode(AppIcon, {
            icon: "mdi-arrow-left",
            size: 18
          }),
          _cache[0] || (_cache[0] = _createTextVNode(" 장바구니로 ", -1))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "mall-quote__print",
          disabled: _unref(isEmpty),
          onClick: onPrint
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-printer-outline",
            size: 18
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" 인쇄 ", -1))
        ], 8, _hoisted_4)
      ])
    ]),
    (!_unref(loaded) || _unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "mall-quote__skel" }, null, -1),
          _createElementVNode("span", { class: "mall-quote__skel mall-quote__skel--wide" }, null, -1),
          _createElementVNode("p", null, "견적서를 준비하는 중입니다", -1)
        ]))]))
      : (_unref(isEmpty))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(AppIcon, {
              icon: "mdi-file-document-outline",
              size: 40
            }),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, "장바구니가 비어 있어 견적서를 만들 수 없습니다.", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("em", null, "상품을 담은 뒤 다시 이용해 주세요.", -1)),
            _createVNode(_component_router_link, { to: "/mall" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("쇼핑계속하기", -1)
              ]))]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("article", _hoisted_7, [
            _createElementVNode("header", _hoisted_8, [
              _createElementVNode("div", null, [
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mall-quote__eyebrow" }, "함우리몰 견적서", -1)),
                _createElementVNode("h1", null, _toDisplayString(orgName.value), 1),
                _createElementVNode("p", _hoisted_9, "작성일 " + _toDisplayString(issuedAt.value), 1)
              ])
            ]),
            _createElementVNode("table", _hoisted_10, [
              _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "상품"),
                  _createElementVNode("th", { class: "is-num" }, "수량"),
                  _createElementVNode("th", { class: "is-num" }, "단가"),
                  _createElementVNode("th", { class: "is-num" }, "금액")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lines), (line) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: line.key
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(line.product.name), 1),
                      (line.optionName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "옵션 · " + _toDisplayString(line.optionName), 1))
                        : _createCommentVNode("", true),
                      (line.product.unit)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(line.product.unit), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(line.qty), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatPrice)(line.unitPrice)) + "원", 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatPrice)(line.lineTotal)) + "원", 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("dl", _hoisted_16, [
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("dt", null, "상품금액", -1)),
                _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(_unref(listSubtotal))) + "원", 1)
              ]),
              _createElementVNode("div", null, [
                _cache[9] || (_cache[9] = _createElementVNode("dt", null, "주문 배송비", -1)),
                _createElementVNode("dd", null, _toDisplayString(_unref(formatShippingFeeAmount)(_unref(shippingFee))), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[10] || (_cache[10] = _createElementVNode("dt", null, "합계", -1)),
                _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(_unref(payable))) + "원", 1)
              ])
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "mall-quote__note" }, " 본 견적서는 장바구니 기준이며, 재고·가격은 주문 시점에 따라 달라질 수 있습니다. ", -1))
          ]))
  ]))
}
}

})